export default "__VITE_ASSET__B1q7G4nO__"